import type { FilterState } from '@/entities/discovery';

/**
 * @description 검색 관련 쿼리 키 모음
 *
 * 계층 구조:
 * - all: 모든 검색 쿼리의 루트 키
 * - searchSuggestionsPrefix: 검색 제안 관련 키의 접두사
 * - searchSuggestions: 특정 검색어와 필터에 대한 제안 결과 키
 *
 * @example
 * ```ts
 * // 검색 제안 조회
 * queryKey: searchKeys.searchSuggestions('table', filters)
 *
 * // 모든 검색 제안 캐시 무효화
 * queryClient.invalidateQueries({ queryKey: searchKeys.searchSuggestionsPrefix() })
 * ```
 */
export const searchKeys = {
  all: ['search'] as const,

  searchSuggestionsPrefix: () => [...searchKeys.all, 'suggestions'] as const,
  searchSuggestions: (query: string, filters: FilterState) =>
    [...searchKeys.searchSuggestionsPrefix(), query, filters] as const,
} as const;
